import { render } from "./InputCode.vue?vue&type=template&id=13a2ea76"
import script from "./InputCode.vue?vue&type=script&lang=js"
export * from "./InputCode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__